@if (showBusyIndicator()) {
    <div class="busy-indicator">
        <div style="height: 100%" class="flex items-center justify-center flex-col">
            <div class="sk-folding-cube" style="margin: 0">
                <div class="sk-cube1 sk-cube"></div>
                <div class="sk-cube2 sk-cube"></div>
                <div class="sk-cube4 sk-cube"></div>
                <div class="sk-cube3 sk-cube"></div>
            </div>
            <h3>Laden</h3>
        </div>
    </div>
}
